

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, State } from "vuex-class"

import vSelect from "vue-select"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import UserImage from "@/components/UserImage.vue"

import { CaseDetails, CaseUser, CaseField, CaseAudit } from "@/types"

import api from "@/services/api"

const caseStore = namespace("cases")

@Component({
	components: {
		"user-image": UserImage,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class History extends Vue {
	@caseStore.Getter("getCurrentCase") public currentCase: any;
	@caseStore.Getter("getCurrentCaseAudit") public auditHistory!: CaseAudit[];

	@caseStore.Action("caseAuditLoad") private caseAuditLoad!: () => void;

	userPictureUrls: { [key: string]: string } = {};

	public mounted () {
		this.caseAuditLoad()
	}

	public userPicture (user: any): string {
		if (user && user.id) {
			const caseUser = this.currentCase.users.find((u: CaseUser) => u.id === user.id)
			if (caseUser) {
				if (caseUser.pictureUrl) {
					return caseUser.pictureUrl!
				} else {
					return api.pictureUrl(user.id)
				}
			} else {
				if (!this.userPictureUrls[user.id]) {
					this.userPictureUrls[user.id] = "images/blank_user.png"
					api.userDetails(user.id).then((userDetails: any) => {
						if (userDetails) {
							if (userDetails.pictureUrl) {
								this.userPictureUrls[user.id] = userDetails.pictureUrl!
							} else {
								this.userPictureUrls[user.id] = api.pictureUrl(user.id)
							}
						}
					})
				}
				return this.userPictureUrls[user.id]
			}
		} else {
			return "images/system_user.png"
		}
	}

	public get lastUpdated (): string {
		if (this.currentCase && this.currentCase.id) {
			return this.currentCase.lastUpdatedAt
		}
		return ""
	}

	@Watch("lastUpdated")
	public onLastUpdatedChanged (newLastUpdated: string, oldLastUpdated: string): void {
		this.caseAuditLoad()
	}
}
